import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "enabled", "label", "dataSelenium"];
import styled from 'styled-components';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useIsStepDataValid } from '../hooks/useIsStepDataValid';
import { Step } from 'signup-constants/Step';
import CreateAccountTermsOfService from './CreateAccountTermsOfService';
import { usePrivacyBanner } from './usePrivacyBanner';
import { devices } from 'signup-constants/styles/viewports.styles';
import { NextButton } from 'signup-components/components/NextButton/NextButton';
import { getStepConfig } from '../views/getStepConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNextButtonWrapper = styled.div.withConfig({
  displayName: "NextButtonWrapper__StyledNextButtonWrapper",
  componentId: "sc-5kgt8d-0"
})(["", " @media ", "{padding-top:", ";", "}@media ", "{", "}@media ", "{", " ", " ", "}"], props => props.isFramedCentredStep && props.currentStep !== Step.LandingPage && `top: 15px;
    position: relative;`, devices.desktop, props => props.isFramedCentredStep && props.currentStep !== Step.LandingPage ? '30px;' : '', props => props.isFramedCentredStep && 'top: 0;', devices.desktop, props => props.currentStep !== Step.LandingPage && isLeftAlignedLayout(props.layoutType) && 'width: 420px;', devices.tablet, props => props.currentStep !== Step.LandingPage && isLeftAlignedLayout(props.layoutType) && 'padding-top: 40px;', props => props.currentStep === Step.UseCase && 'padding-top: 30px;', props => props.currentStep === Step.UseCase && `
      width: 365px;
      margin-left: auto;
      margin-right: auto;
    `);
const NextButtonWrapper = _ref => {
  let {
      onClick,
      enabled,
      label,
      dataSelenium
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    shouldShowToSNonOptionalStep,
    shouldShowToSOptionalStep
  } = usePrivacyBanner();
  const {
    currentStep
  } = useCurrentStep();
  const customButtonLabelI18n = `views.${currentStep}.buttonLabel`;
  const isStepDataValid = useIsStepDataValid(currentStep);
  const stepConfig = getStepConfig(currentStep);
  const {
    layoutType
  } = useLayoutTemplate();
  const isEnabled = typeof enabled === 'boolean' ? enabled : isStepDataValid;
  let buttonLabel =
  // eslint-disable-next-line no-nested-ternary
  label && isValidI18nKey(label) ? label : isValidI18nKey(customButtonLabelI18n) ? customButtonLabelI18n : 'button.next';
  if (shouldShowToSNonOptionalStep || shouldShowToSOptionalStep) buttonLabel = 'button.createAccount';
  const onSubmit = event => {
    event.preventDefault();
    onClick();
  };
  const shouldShowIcon = stepConfig && stepConfig.showNextButtonIcon;
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const dataSeleniumAttr = dataSelenium || `${currentStep}_button`;
  return /*#__PURE__*/_jsxs(StyledNextButtonWrapper
  // @ts-expect-error Expression produces a union type that is too complex to represent.
  , {
    currentStep: currentStep,
    isFramedCentredStep: isFramedCentredStep,
    layoutType: layoutType,
    children: [/*#__PURE__*/_jsx(NextButton, Object.assign({
      buttonLabel: buttonLabel,
      className: `width-100 ${isStepDataValid && 'DataValid'}`,
      dataSelenium: dataSeleniumAttr,
      isEnabled: isEnabled,
      label: buttonLabel,
      showIcon: shouldShowIcon,
      onClick: onSubmit
    }, props)), shouldShowToSNonOptionalStep && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
  });
};
export default NextButtonWrapper;